import axios from "axios";

const service = axios.create({
  timeout: 30000, // request timeout
  headers: { "ngrok-skip-browser-warning": "covomo" },
});

const pendingRequests = new Map();

const getPendingKey = (config) => {
  const url = config?.url || "";
  const method = (config?.method || "get").toLowerCase();

  if (url.includes("tariffs")) {
    return `${method}:${url.split("?")[0]}`;
  }

  return `${method}:${url}`;
};
const clearPendingRequest = (config) => {
  const key = getPendingKey(config);
  const controller = pendingRequests.get(key);
  if (controller?.signal === config?.signal) {
    pendingRequests.delete(key);
  }
};
service.interceptors.request.use(
  (config) => {
    const url = config?.url || "";
    if (!url.includes("tariffs")) {
      return config;
    }
    const key = getPendingKey(config);
    pendingRequests.get(key)?.abort();
    const controller = new AbortController();
    config.signal = controller.signal;
    pendingRequests.set(key, controller);
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor to remove the request from the map once finished
service.interceptors.response.use(
  (response) => {
    clearPendingRequest(response.config);
    return response;
  },
  (error) => {
    if (error?.config) {
      clearPendingRequest(error.config);
    }
    return Promise.reject(error);
  },
);

export default function request(options) {
  return service(options);
}
